import { render, staticRenderFns } from "./historyChat.vue?vue&type=template&id=30483e1e&scoped=true"
import script from "./historyChat.vue?vue&type=script&lang=js"
export * from "./historyChat.vue?vue&type=script&lang=js"
import style0 from "./historyChat.vue?vue&type=style&index=0&id=30483e1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30483e1e",
  null
  
)

export default component.exports